import React from "react";
import ProductDetailLeftSide from "../../components/ProductDetailLeftSide";
import "./styles.css"
import ProductDetailRigthSide from "../../components/ProductDetailRigthSide"
import ProductDetailPolicy from "../../components/ProductDetailPolicy"
import CarouselProductsTopSale from "../../components/CarouselProductsTopSale"

interface Iprops_detail {}

const Detail: React.FC<Iprops_detail> = () => {
  return (
    <div className="productDetail">
      <div className="productDetailSides">
        <ProductDetailLeftSide />
        <ProductDetailRigthSide/>
      </div>
        <ProductDetailPolicy/>
        <CarouselProductsTopSale/>
    </div>
  );
};

export default Detail;
